import React from "react";
import "./Header.css";
import {toggleTheme} from "../../utils/themeUtils";
import {APP_SUBTITLE, APP_TITLE} from "../../constants";

const Header = ({theme}) => {
	return (
		<header className="app-header">
			<div className="app-header-left">
				<h1 className="app-title">
					<img
						src="/icons/icon-48x48.png"
						alt={APP_TITLE}
						aria-hidden="true"
						className="app-title-logo"
					/>
					{APP_TITLE}
				</h1>
				<p className="app-subtitle">
					{APP_SUBTITLE}
				</p>
			</div>

			<div className="app-header-right">
				<ThemeToggle theme={theme}/>
			</div>
		</header>
	)
}

const ThemeToggle = ({theme}) => {
	return (
		<button
			type="button"
			className="theme-toggle"
			onClick={toggleTheme}
			role="switch"
			aria-checked={theme === "dark"}
			aria-label="Toggle light/dark theme"
		>
                <span className="theme-toggle-track" aria-hidden="true">
                  <span className={"theme-toggle-thumb" + (theme === "dark" ? " theme-toggle-thumb--right" : "")}>
                    <span className="material-symbols-outlined" aria-hidden="true">
                      {theme === "dark" ? "dark_mode" : "light_mode"}
                    </span>
                  </span>
                </span>
			<span className="theme-toggle-label">{theme === "dark" ? "Dark" : "Light"}</span>
		</button>
	)
}

export default Header;